//#region src/cli_config.ts
const CRED_STORAGE_FILE = "file";
const CRED_STORAGE_KEYRING = "keyring";
//#endregion
export { CRED_STORAGE_FILE, CRED_STORAGE_KEYRING };

//# sourceMappingURL=cli_config.js.map